export default () => ({
    topSection: null
})